export default () => ({
    topSection: null
})